import { fetch } from '../utils/fetch'

// 开启的crm列表
export function getAddonCompanyAllList() {
  return fetch({
    url: `/crmMultiModule/queryAllList`,
    method: 'get'
  })
}

// 多crm列表
export function getAddonCompanyList(data) {
  return fetch({
    url: `/crmMultiModule/queryList`,
    method: 'post',
    data
  })
}

// 创建/编辑crm
export function handleCompany(data) {
  return fetch({
    url: `/crmMultiModule/save`,
    method: 'post',
    data
  })
}

// 删除crm
export function deleteCompany(id) {
  return fetch({
    url: `/crmMultiModule/delete/${id}`,
    method: 'get'
  })
}
// 更改状态
export function updateState(id, state) {
  return fetch({
    url: `/crmMultiModule/updateState/${id}/${state}`,
    method: 'get'
  })
}

// 获取KEY
export function getKeyList() {
  return fetch({
    url: `/crmMultiModule/querykey`,
    method: 'get'
  })
}
